<template>
  <div class="app">
    <Navbar />
    <div class="main-content">
      <router-view></router-view>
    </div>
    <SlideNav />
    <Bottom />
  </div>
</template>

<script setup>
import Navbar from '@/components/common/Navbar.vue'
import Bottom from '@/components/common/Bottom.vue'
import SlideNav from '@/components/common/SlideNav.vue';
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.main-content{
  background-color: #fff;
  }
.app {
  width: 100%;
  height: 100vh;
}
@media screen and (max-width: 768px) {
  .main-content{
    margin-top: 53px;
  }
}


</style>